import { AccountsServiceClient } from '@pushwoosh/rpc-service-client/pushwoosh/accounts/AccountsServiceClientPb';
import { Account, BillingAddress, BillingInfo, GetAccountRequest, GetAccountResponse, GetActiveDevicesCountRequest, GetActiveDevicesCountResponse, GetActiveUsersCountRequest, GetActiveUsersCountResponse, GetBillingAddressRequest, GetBillingAddressResponse, GetBillingInfoRequest, GetBillingInfoResponse, GetEmailStatisticCountRequest, GetEmailStatisticCountResponse, GetOnboardingInfoRequest, GetOnboardingInfoResponse, GetSubscribersCountRequest, GetSubscribersCountResponse, GetTotalEmailSubscribersCountRequest, GetTotalEmailSubscribersCountResponse, SetDebugModeRequest, SetDebugModeResponse, UpdateAccountRequest, UpdateAccountResponse, UpdateBillingAddressRequest, UpdateBillingAddressResponse, UpdateBillingInfoRequest, UpdateBillingInfoResponse, UpdateOnboardingInfoRequest, UpdateOnboardingInfoResponse, } from '@pushwoosh/rpc-service-client/pushwoosh/accounts/accounts_pb';
export const accounts = {
    AccountsServiceClient,
    Account,
    BillingAddress,
    BillingInfo,
    GetAccountRequest,
    GetAccountResponse,
    GetActiveDevicesCountRequest,
    GetActiveDevicesCountResponse,
    GetActiveUsersCountRequest,
    GetActiveUsersCountResponse,
    GetBillingAddressRequest,
    GetBillingAddressResponse,
    GetBillingInfoRequest,
    GetBillingInfoResponse,
    GetEmailStatisticCountRequest,
    GetEmailStatisticCountResponse,
    GetOnboardingInfoRequest,
    GetOnboardingInfoResponse,
    GetSubscribersCountRequest,
    GetSubscribersCountResponse,
    GetTotalEmailSubscribersCountRequest,
    GetTotalEmailSubscribersCountResponse,
    SetDebugModeRequest,
    SetDebugModeResponse,
    UpdateAccountRequest,
    UpdateAccountResponse,
    UpdateBillingAddressRequest,
    UpdateBillingAddressResponse,
    UpdateBillingInfoRequest,
    UpdateBillingInfoResponse,
    UpdateOnboardingInfoRequest,
    UpdateOnboardingInfoResponse,
};
